export default __webpack_public_path__ + "static/media/travel.61588211.png";